define([
	"dojo/_base/declare",
	"csi/action/AggregateController",
	"csi/xml/Query",
	"csi/xml",
	"SourcingOrders"
], function(declare,AggregateController,Query,xml,SourcingOrders) {
	
	return declare(AggregateController, {
		
		getFormData: function() {
			var	data = this.inherited(arguments);
			var config = this.m_cache.getNode(SourcingOrders.CONFIG, true);
			data.m_bSelectOne = config.OneShipmentsPerPO;
			data.m_bRequireOne = true;
			return data;
		},
		
		applyActionFilters: function(/*csi.view.Widget*/view) {
			// summary: modify ShipmentTerms aggregation view to show only PO based ShipmentTerms.		
			// shipmentTerms' Mode == POLineItems
			view.relRoot.addQuery(new Query().Attr("Mode", xml.OP_EQUALS, "ShipmentMode:POLineItems"));
			this.inherited(arguments);
		},
		
		postProcess: function(/*Boolean*/bStatus) {
			// summary: when one shipment is added or created, the radio button should be set for that new entry
			// when more than one shipment is selected then do not change the radio button selection
			this.inherited(arguments);
			
			var addedNodes = this.m_formData.getSelectedNodes();
			if (addedNodes.length == 1) {
				this.widget.defView.getFormData().changeSelection(this.widget.getContext(addedNodes[0].$URL), true);
			}
		}
	});
});